/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WalletType } from './WalletType';
import {
    WalletTypeFromJSON,
    WalletTypeFromJSONTyped,
    WalletTypeToJSON,
    WalletTypeToJSONTyped,
} from './WalletType';

/**
 * Represents a signed wallet for a particular account.
 * @export
 * @interface EvmWallet
 */
export interface EvmWallet {
    /**
     * 
     * @type {string}
     * @memberof EvmWallet
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof EvmWallet
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof EvmWallet
     */
    updatedAt: number;
    /**
     * 
     * @type {WalletType}
     * @memberof EvmWallet
     */
    type: WalletType;
    /**
     * 
     * @type {string}
     * @memberof EvmWallet
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof EvmWallet
     */
    user: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EvmWallet
     */
    webhookIds?: Array<string>;
}



/**
 * Check if a given object implements the EvmWallet interface.
 */
export function instanceOfEvmWallet(value: object): value is EvmWallet {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    return true;
}

export function EvmWalletFromJSON(json: any): EvmWallet {
    return EvmWalletFromJSONTyped(json, false);
}

export function EvmWalletFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvmWallet {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'type': WalletTypeFromJSON(json['type']),
        'address': json['address'],
        'user': json['user'],
        'webhookIds': json['webhookIds'] == null ? undefined : json['webhookIds'],
    };
}

export function EvmWalletToJSON(json: any): EvmWallet {
    return EvmWalletToJSONTyped(json, false);
}

export function EvmWalletToJSONTyped(value?: EvmWallet | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'type': WalletTypeToJSON(value['type']),
        'address': value['address'],
        'user': value['user'],
        'webhookIds': value['webhookIds'],
    };
}

